import { Portal } from '@aviv-estimation-funnel/estimation-data-models/enums';
import { TAppEnv } from '@mfe-types/env';

export const getPortalUrl = (portal: Portal) => {
    const env = process.env.NX_TASK_TARGET_CONFIGURATION as TAppEnv;
    const env_domain = env === 'production' ? 'www' : env === 'preview' ? env : 'dev';

    switch (portal) {
        case Portal.Immonet:
            return `https://${env_domain}.immonet.de`;
        case Portal.ImmoWelt:
            return `https://${env_domain}.immowelt.de`;
        case Portal.ImmoWeb:
            return `https://${env === 'preview' ? 'test' : env_domain}.immoweb.be`;
        case Portal.SeLoger:
            return `https://${env_domain}.seloger.com`;
        case Portal.LogicImmo:
            return `https://${env_domain}.logic-immo.com`;
        default:
            throw new Error(`Portal ${portal} is not supported`);
    }
};
